import { IGatsbyImageData } from 'gatsby-plugin-image/dist/src/components/gatsby-image.browser';

export const useExtractImagesFromGqlData = (
  graphqlData: Record<string, any>
) => {
  return graphqlData.images.edges.map(
    (item: {
      node: {
        childImageSharp: { gatsbyImageData: IGatsbyImageData };
      };
    }) => item.node.childImageSharp.gatsbyImageData
  );
};
